import { ILead } from "./ILead";
import { IUser } from "./IUser";
import { IChaseActivity } from "./IChaseActivity";

export interface IChaseAttributes {
  id: number;
  aasmState: ChaseState;
  activities: IChaseActivity[];
  createdAt: string;
  hotAt?: string;
  lead?: ILead;
  leadId: number;
  qualifiedAt?: string;
  updatedAt: string;
  userId: number;
  user: IUser;
}
export interface IChase {
  id: string;
  attributes: IChaseAttributes;
}

export enum ChaseState {
  ACTIVE = "active",
  MARKED_QUALIFIED = "marked_qualified",
  QUALIFIED = "qualified",
  MARKED_HOT = "marked_hot",
  HOT = "hot",
  CLOSED = "closed",
}
